export enum ECsvColumnType {
    BOOLEAN = 'boolean',
    DATE_TIME = 'date_time',
    NUMBER = 'number'
}
